var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { id: "404" } },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "fill-height": "" } },
        [
          _c(
            "v-layout",
            { attrs: { "align-center": "", "justify-center": "" } },
            [
              _c("div", { staticClass: "mr-3 hidden-sm-and-down" }, [
                _c("img", { attrs: { src: "src/assets/error/404.svg" } }),
              ]),
              _c("div", { staticClass: "text-md-center" }, [
                _c("h1", [_vm._v("404")]),
                _c("h2", { staticClass: "my-3 headline" }, [
                  _vm._v(" Sorry, page not found "),
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "primary" },
                        on: { click: _vm.goHome },
                      },
                      [_vm._v(" Go Home ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }